import { useState } from 'react';
import centralDistrictImage from '../assets/images/opportunities/central-district-9.png';
import greensAtWakadImage from '../assets/images/opportunities/greens-at-wakad.png';
import meridianTowerImage from '../assets/images/opportunities/meridian-tower.png';
import SectionHeader from './SectionHeader.jsx';
import {
  DistrictGraphic,
  GreensGraphic,
  MeridianGraphic,
} from './graphics/OpportunityGraphics.jsx';

const graphicMap = {
  district: DistrictGraphic,
  greens: GreensGraphic,
  meridian: MeridianGraphic,
};

const opportunities = [
  {
    tag: 'High-Density Optimization',
    name: 'Meridian Tower',
    location: 'Baner, Pune',
    minimumInvestment: '\u20B975 Lakh',
    irr: '22-28%',
    status: 'OPEN',
    statusClass: 'st-open',
    image: meridianTowerImage,
    imageRatio: '2 / 3',
    imageFit: 'cover',
    imagePosition: 'center top',
    imageStyle: { background: 'linear-gradient(135deg,#0a1628,#0d2040,#071830)' },
    graphic: 'meridian',
  },
  {
    tag: 'Luxury Low-Rise',
    name: 'Greens at Wakad',
    location: 'Wakad, Pune',
    minimumInvestment: '\u20B950 Lakh',
    irr: '29-35%',
    status: 'CLOSING SOON',
    statusClass: 'st-closing',
    cardStyle: { borderColor: 'rgba(0,212,200,.35)' },
    image: greensAtWakadImage,
    imageRatio: '2 / 3',
    imageFit: 'cover',
    imagePosition: 'center top',
    imageStyle: { background: 'linear-gradient(135deg,#0a1c14,#0d2818,#071a10)' },
    irrStyle: { color: '#ffa000' },
    graphic: 'greens',
  },
  {
    tag: 'Mixed-Use Development',
    name: 'Central District 9',
    location: 'Kharadi, Pune',
    minimumInvestment: '\u20B91 Cr',
    irr: '18-24%',
    status: 'OPEN',
    statusClass: 'st-open',
    image: centralDistrictImage,
    imageRatio: '2 / 3',
    imageFit: 'cover',
    imagePosition: 'center top',
    imageStyle: { background: 'linear-gradient(135deg,#1a0a28,#200d40,#160730)' },
    graphic: 'district',
  },
];

function OpportunitiesSection() {
  const [imageErrors, setImageErrors] = useState({});

  const handleImageError = (oppName) => {
    setImageErrors((prev) => ({
      ...prev,
      [oppName]: true,
    }));
  };

  return (
    <section id="opportunities" data-section className="section-opportunities fade-up">
      <div className="section-wrap">
        <SectionHeader
          label="Live Deals"
          title="Investment Opportunities"
          subtitle="Carefully structured, architecturally validated investment opportunities open now."
        />

        <div className="cards-container">
          {opportunities.map((opportunity) => {
            const Graphic = graphicMap[opportunity.graphic];

            return (
              <div key={opportunity.name} className="card-box" style={opportunity.cardStyle}>
                <div className="card-image">
                  {!imageErrors[opportunity.name] ? (
                    <>
                      <img
                        src={opportunity.image}
                        alt={opportunity.name}
                        style={{
                          objectFit: opportunity.imageFit,
                          objectPosition: opportunity.imagePosition,
                        }}
                        loading="lazy"
                        onError={() => handleImageError(opportunity.name)}
                      />
                      <div className="opp-graphic-overlay">
                        <Graphic />
                      </div>
                    </>
                  ) : (
                    <div className="opp-graphic-fallback" style={opportunity.imageStyle}>
                      <Graphic />
                    </div>
                  )}
                  {opportunity.status && (
                    <span className={`badge ${opportunity.statusClass}`}>{opportunity.status}</span>
                  )}
                </div>

                <div className="card-content">
                  <div className="card-text">
                    <h3 className="card-title">{opportunity.name}</h3>
                    <p className="card-desc">{opportunity.tag}</p>
                  </div>

                  <div className="card-basic-info">
                    <div className="info-row">
                      <span>{opportunity.location}</span>
                      <span
                        style={{
                          display: 'inline-block',
                          whiteSpace: 'nowrap',
                          color: '#00ffff',
                          fontWeight: '300',
                          textShadow: '0 0 1px #00ffff, 0 0 2px #00ffff, 0 0 4px #00ffff',
                        }}
                      >
                        Min Investment: {opportunity.minimumInvestment}
                      </span>
                    </div>
                  </div>

                  <div className="card-hover-container">



                    <ul className="card-hover-details">
                      <li className="detail-item detail-heading">
                        <div className="detail-value">{opportunity.name}</div>
                        <p className="detail-subheading">{opportunity.tag}</p>
                      </li>

                      <li className="detail-item">
                        <div className="detail-value"> Location : {opportunity.location}</div>
                        {/* <span className="detail-label">Location</span> */}
                      </li>
                      <li className="detail-item">
                        <div className="detail-value" style=  {opportunity.irrStyle}>
                          Projected ROI : {opportunity.irr}
                        </div>
                        {/* <span className="detail-label">Projected ROI</span> */}
                      </li>
                    
                    </ul>

                    <a className="view-program" href="#contact">
                      <div className="btn-content">
                        <h5 className="btn-text">View Details</h5>
                        <svg
                          className="btn-icon"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M4 12H20M20 12L14 6M20 12L14 18"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mobile-cards-container">
          {opportunities.map((opportunity) => {
            const Graphic = graphicMap[opportunity.graphic];

            return (
              <a
                key={`mobile-${opportunity.name}`}
                className="mobile-card"
                href="#contact"
                style={opportunity.cardStyle}
              >
                <div className="card-image">
                  {!imageErrors[opportunity.name] ? (
                    <>
                      <img
                        src={opportunity.image}
                        alt={opportunity.name}
                        style={{
                          objectFit: opportunity.imageFit,
                          objectPosition: opportunity.imagePosition,
                        }}
                        loading="lazy"
                        onError={() => handleImageError(opportunity.name)}
                      />
                      <div className="opp-graphic-overlay">
                        <Graphic />
                      </div>
                    </>
                  ) : (
                    <div className="opp-graphic-fallback" style={opportunity.imageStyle}>
                      <Graphic />
                    </div>
                  )}
                  {opportunity.status && (
                    <span className={`badge ${opportunity.statusClass}`}>{opportunity.status}</span>
                  )}
                </div>

                <div className="card-text">
                  <h3 className="card-title">{opportunity.name}</h3>
                  <p className="card-desc">{opportunity.tag}</p>
                </div>

                <ul className="mobile-details">
                  <li className="detail-item">
                    <div className="detail-value"> Location : {opportunity.location}</div>
                    {/* <span className="detail-label">Location</span> */}
                  </li>
                  <li className="detail-item">
                    <div className="detail-value" style={opportunity.irrStyle}>
                     Projected ROI : {opportunity.irr}
                    </div>
                    {/* <span className="detail-label">Projected ROI</span> */}
                  </li>
                  <li className="detail-item">
                    <div className="detail-value"> Minimum Investment : {opportunity.minimumInvestment}</div>
                    {/* <span className="detail-label">Minimum Investment</span> */}
                  </li>
                </ul>

                <div className="view-program">
                  View Details <span>&rarr;</span>
                </div>
              </a>
            );
          })}
        </div>

        <div className="opp-cta">
          <a href="#contact" className="link-arrow">
            View All Opportunities <span>&rarr;</span>
          </a>
        </div>
      </div>
    </section>
  );
}

export default OpportunitiesSection;

